import { store } from '../store/store';
import { SmartLaunchType } from '@/constants/enums';

/// False only for an embedded SMART launch whose SmartFhirConfig:*:CompatibleApplicationKeys whitelist omits the app;
/// external and non-SMART sessions are unrestricted.
export default function IsSmartCompatibleApp(appKey: string): boolean {
    const isEmbeddedLaunch = store.state.launchType === SmartLaunchType.Embedded;
    const isWhitelisted = store.state.smartCompatibleApplicationKeys?.includes(appKey) ?? false;
    return !isEmbeddedLaunch || isWhitelisted;
}
